import facebook from './_assets/facebook.png'
import twitterX from './_assets/x-twitter.svg'
import instagram from './_assets/instagram.png'
import youtube from './_assets/youtube.png'

const iconsMap = {
  facebook,
  twitterX,
  instagram,
  youtube
}

export default iconsMap
